import { PageProps } from 'gatsby'
import { Detail } from 'components/customers'
import { SEO } from 'components/common'

export const Head = () => <SEO title={'顧客（個人）管理'} />

const IndexPage = ({
  params: { id },
}: PageProps<Queries.Query>): JSX.Element => {
  return (
    <>
      <Detail id={id} type="personal" />
    </>
  )
}

export default IndexPage
